document.addEventListener('DOMContentLoaded', function () {
    let sliderElement = document.getElementById('image-block-panel-slider');
    let collectionNavSlider;

    function shouldInitializeSlider() {
        if (!sliderElement) return false;
        
        const slides = sliderElement.querySelectorAll('.splide__slide');
        const slideCount = slides.length;
        const screenWidth = window.innerWidth;
        
        // Kill slider if 3 items or less and screen width is above 1280px
        if (slideCount <= 3 && screenWidth > 1280) {
            return false;
        }
        
        return true;
    }

    function initializeSlider() {
        if (sliderElement && shouldInitializeSlider()) {
            collectionNavSlider = new Splide('#image-block-panel-slider', {
                type: 'slide',
                pagination: false,
                snap: true,
                autoWidth: true,
                lazyLoad: false, 
                flickPower: 300,
                focus: 'center', 
                gap: '1rem',
                arrows: false,
                breakpoints: {
                    1280: { 
                        omitEnd: false,
                        focus: 'center', 
                        padding: { left: '4rem', right: '4rem'}
                    }, 
                    450: { 
                        gap: '0.5rem',
                        padding: { left: '2rem', right: '2rem'}
                    }
                }
            });

            collectionNavSlider.mount();

            // Prevent slider movement when clicking links
            const slideLinks = sliderElement.querySelectorAll('a');
            slideLinks.forEach(link => {
                link.addEventListener('click', function(e) {
                    e.stopPropagation();
                });
            });
        } else if (sliderElement) {
            // Remove splide classes to display as normal flex layout
            sliderElement.classList.remove('splide');
            const track = sliderElement.querySelector('.splide__track');
            const list = sliderElement.querySelector('.splide__list');
            
            if (track) track.classList.remove('splide__track');
            if (list) {
                list.classList.remove('splide__list');
                list.classList.add('flex', 'justify-center', 'gap-4');
            }
            
            const slides = sliderElement.querySelectorAll('.splide__slide');
            slides.forEach(slide => {
                slide.classList.remove('splide__slide');
            });
        }
    }

    function handleResize() {
        // Destroy existing slider if it exists
        if (collectionNavSlider) {
            collectionNavSlider.destroy();
            collectionNavSlider = null;
        }
        
        // Reset classes
        if (sliderElement) {
            sliderElement.classList.add('splide');
            const track = sliderElement.querySelector('.splide__track, div[class*="justify-center"]');
            const list = sliderElement.querySelector('.splide__list, ul[class*="flex"]');
            
            if (track) {
                track.className = 'splide__track xlg:flex xlg:justify-center';
            }
            if (list) {
                list.className = 'splide__list';
            }
            
            const slides = sliderElement.querySelectorAll('li');
            slides.forEach(slide => {
                if (!slide.classList.contains('splide__slide')) {
                    slide.classList.add('splide__slide');
                }
            });
        }
        
        // Reinitialize
        initializeSlider();
    }

    // Initialize on load
    initializeSlider();

    // Handle window resize
    window.addEventListener('resize', handleResize);
});